import { render, staticRenderFns } from "./portal-layout.vue?vue&type=template&id=9c6a2c0c&scoped=true"
import script from "./portal-layout.vue?vue&type=script&lang=js"
export * from "./portal-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6a2c0c",
  null
  
)

export default component.exports